/**
 * Given a value interpreted as text, determine whether to display it or not based on whether it is empty.
 * @param {object} candidate candidate object.
 * @returns {object} formatted name first/last or null.
 */
export default function displayCandidateName(candidate) {
  // Fetch values from object.
  const {
    first_name: firstName = '',
    full_name: fullName = '',
    last_name: lastName = '',
  } = candidate;

  // Return first and last if they both exist.
  if (firstName && lastName) {
    return {
      first: firstName,
      last: lastName,
    };
  }

  // If we've got this far, we don't have first and last, so try full and split for each.
  if (fullName) {
    // Check for spaces; if none, bail
    if (! fullName.includes(' ')) {
      return {
        first: '',
        last: fullName,
      };
    }

    // Get everything before first space.
    const first = fullName.split(' ', 1)[0];

    // Get everything else, and strip the first string which is always a space.
    const last = fullName.replace(first, '').substring(1);

    return {
      first,
      last,
    };
  }

  return null;
}
